import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

@Injectable()
export class MenuOptionsActions implements IMenuOptionsActions {

  static ADD = '[Options] ADD';

  constructor(private _store: Store<IAppState>) {}

  public Add(options: {[key:string]: Array<string>}) {
    this._store.dispatch( {
        type:  MenuOptionsActions.ADD,
        payload: options
      });
  }
}
